import { Component, OnInit, OnDestroy } from '@angular/core';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { sweetAlert } from 'src/app/utils/swal';
import { MaintenanceService } from '../maintenance-service/maintenance.service';
import { takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { FleetService } from '../../fleet/fleet-service/fleet.service';
import { getCompanyLogo } from 'src/app/utils/utils.common';
import { CompaniesService } from '../../companies/service/companies.service';
import { CsvService } from 'src/app/service/csv-service/csv.service';
import * as moment from "moment-timezone";
@Component({
  selector: 'app-vehicle-expenses',
  templateUrl: './vehicle-expenses.component.html',
  styleUrls: ['./vehicle-expenses.component.css']
})
export class VehicleExpensesComponent implements OnInit, OnDestroy {
  user;
  search;
  selectedVehicle;
  fleetList;
  vehicleExpenses;
  timeZone;
  vehicleDetailModalObj;
  vehicles;
  dateRange:any;

  constructor(
    private fleetService: FleetService,
    private sharedDataService: SharedDataService,
    private maintenanceService: MaintenanceService,
    private csvService: CsvService
    
  ) { }

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = user.timeZone;
          this.dateRange = [
            moment.tz(this.timeZone).startOf("day").toISOString(),
            moment.tz(this.timeZone).endOf("day").toISOString(),
          ];
          this.getFleetList();

        }
      });
  }

  getFleetList() {
    this.fleetService
      .getFleetList({ 'isFleetSection': true, 'status': 'active' })
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {

          if (data) {
            this.fleetList = data;
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }
  getFleetbyId(id) {
    this.fleetService.getFleetDataById(id).subscribe((data) => {
      if (data) {
        this.vehicles = data      }
    })
  }

  getCompanyImage(driverCar) {
    return getCompanyLogo(driverCar);
  }

  getVehicleExpense(id) {
    
    const params = {
      startDate: this.dateRange[0],
      endDate: this.dateRange[1],
    }

    this.maintenanceService.getVehicleExpense(id, params)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe((data) => {
        if (data && data.maintenances && data.maintenances.length) {
          this.vehicleExpenses = data.maintenances;
        }
      });
  }

  onSelectVehicle(vehicle) {
    this.selectedVehicle = vehicle;
    this.vehicleExpenses = null;
     this.dateRange = [
    moment.tz(this.timeZone).startOf('day').toISOString(),
    moment.tz(this.timeZone).endOf('day').toISOString(),
  ];
    this.getVehicleExpense(vehicle._id);
    this.getFleetbyId(vehicle._id)
  }

  openVehicleDetailModal(vehicleData) {
    this.vehicleDetailModalObj = vehicleData;
  }

  ngOnDestroy(): void {
  }

  getVmlReport(payload) {
    this.csvService.getVehicleMaintenanceReport(payload)
  }

    onDateRangeChange(event) {
      const duration = moment.duration(event[1].diff(event[0]));
      const diffInDays = duration.asMonths();
      if (diffInDays < 1) {
        this.dateRange = [
          event[0].toISOString(),
          event[1].endOf("day").toISOString(),
        ];
        this.getVehicleExpense(this.selectedVehicle._id);
        return;
      }
  
      this.dateRange = [];
      sweetAlert("Error", 'You can only select a date range of up to 30 days.', "warning", "Ok");
  
    }

}
